import { CSSProperties, ReactNode } from 'react';
import { ActionIcon, Center, Checkbox, Tooltip } from '@mantine/core';
import { InsightField } from '@/types/automationFields.ts';
import ExpandingInputCell from '../ExpandingInputCell.tsx';
import { HiOutlineTrash } from 'react-icons/hi2';

export interface InsightFieldColumnDef {
  header: string;
  styles?: CSSProperties;
  cell: (props: {
    row: InsightField;
    update: (field: Partial<InsightField>) => void;
    allRows: InsightField[];
    deleteRow: () => void;
  }) => ReactNode;
  width?: string;
}

export const insightFieldTableColumns: InsightFieldColumnDef[] = [
  {
    header: 'Name',
    styles: { minWidth: '200px' },
    cell: ({ row, update }) => (
      <ExpandingInputCell
        value={row.name || ''}
        placeholder="field name"
        onChange={(event) => update({ name: event.currentTarget.value })}
        header={'Name'}
      />
    ),
  },
  {
    header: 'Description',
    cell: ({ row, update }) => (
      <ExpandingInputCell
        value={row.description || ''}
        placeholder="description"
        onChange={(event) => update({ description: event.currentTarget.value })}
        header={'Description'}
      />
    ),
  },
  {
    header: 'Infer Answers',
    cell: ({ row, update }) => (
      <Center>
        <Checkbox
          size={'xs'}
          checked={row.infer_answer}
          onChange={(event) => update({ infer_answer: event.currentTarget.checked })}
        />
      </Center>
    ),
  },
  {
    header: 'Internet Access',
    styles: { maxWidth: '50px' },
    cell: ({ row, update }) => (
      <Tooltip
        label="Internet access is disabled if infer answers is disabled"
        disabled={row.infer_answer}
        openDelay={250}
      >
        <Center>
          <Checkbox
            size={'xs'}
            checked={row.infer_answer ? row.internet_access : false}
            disabled={!row.infer_answer}
            onChange={() => update({ internet_access: !row.internet_access })}
          />
        </Center>
      </Tooltip>
    ),
  },
  {
    header: '',
    cell: ({ deleteRow }) => (
      <Center>
        <ActionIcon variant={'subtle'} color={'gray'} onClick={() => deleteRow()}>
          <HiOutlineTrash size={16} />
        </ActionIcon>
        {/*<Checkbox checked={false} onChange={() => {}} size="xs" />*/}
      </Center>
    ),
  },
];
